<div
  fxLayout="row"
  fxLayout.xs="column"
  fxLayoutAlign="space-around"
  class="footer"
  style=""
>
  <div fxFlex="25">
    <h3>TCA Copyright@2020</h3>
  </div>

  <div fxFlex="25">
    <h3>Quick Links</h3>
    <a routerLink="/eligibility" mat-button>Selection Process</a>
    <!-- <a routerLink="/training" mat-button>Training</a> -->
    <a routerLink="/courses" mat-button>Courses</a>
    <a routerLink="/faq" mat-button>FAQs</a>
    <a routerLink="/team" mat-button>About Us</a>
  </div>

  <div fxFlex="25">
    <h3>Contact</h3>
    <p>
      <i class="ion-md-mail"></i
      ><a href="mailto:info@topcrewaviation.com?Subject=Hello" target="_blank">
        info@topcrewaviation.com</a
      >
    </p>
    <!-- <p><i  class="ion-md-call"></i><a href="tel:01414106757" target="_blank"> +91 1414106757</a></p> -->
    <p>608, Okay Plus Square, Mansarovar, jaipur, Rajasthan 302020</p>
  </div>

  <div fxFlex="25">
    <h3>Social</h3>
    <p>
      <i class="ion-logo-whatsapp"></i
      ><a href="https://wa.me/9180944 49995" target="_blank"> 80944 49995</a>
    </p>
    <p>
      <i class="ion-logo-facebook"></i
      ><a href="https://fb.com/tcapilot" target="_blank"> tcapilot</a>
    </p>
    <p>
      <i class="ion-logo-instagram"></i
      ><a href="https://instagram.com/topcrewin" target="_blank"> topcrewin</a>
    </p>
    <p>
      <i class="ion-logo-youtube"></i
      ><a
        href="https://www.youtube.com/channel/UCa6dghfL0chom_A4j0kXxuQ"
        target="_blank"
      >
        Top Crew Aviation</a
      >
    </p>
  </div>
</div>
